export default "__VITE_ASSET__da96cce4__"